import React from 'react'

import PlacesList from './PlacesList'
import PlacesLoader from '../_load/PlacesLoader'

const PageContent = () => {
  return (
    <PlacesLoader>
      <PlacesList />
    </PlacesLoader>
  )
}

export default PageContent
